"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
var _Radio = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Radio"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _VersionDropdown = _interopRequireDefault(require("./VersionDropdown"));
var _ResultsLoading = _interopRequireDefault(require("./ResultsLoading"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "empty": "empty_1pJbhN",
  "asset-name": "asset-name_3PMXbu",
  "assetName": "asset-name_3PMXbu",
  "message": "message_13MEtp",
  "check-cell": "check-cell_SYeT20",
  "checkCell": "check-cell_SYeT20",
  "check": "check_3P93v_",
  "no-wrap": "no-wrap_2AC67M",
  "noWrap": "no-wrap_2AC67M"
}; 
require('./Results.css');
var EmptyResultsIcon = function EmptyResultsIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m386.165 144.113-35.417-27.45-25.135 20.587M332.849 129.625l-7.236-6.1-24.754 20.587",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M405.969 144.494h-118.82",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m380.15 134.069 2.29 7.843-4.811-3.584 1.051-4.229a.761.761 0 0 1 1.47-.03Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m383.621 131.019 3.856 13.21-3.457-2.203-3.977-2.499 2.107-8.478a.762.762 0 0 1 1.471-.03ZM303.193 133.25l-3.252 11.625 6.393-5.638-1.674-5.987a.762.762 0 0 0-1.467 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M234.593 144.494h9.14M54.078 144.494h175.183",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m80.668 122.033 2.652 12.495-9.093 7.789 4.956-20.306a.762.762 0 0 1 1.485.022ZM200.29 118.522l4.598 16.441-8.553-7.544 2.488-8.897a.762.762 0 0 1 1.467 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m84.519 126.086 2.007 7.535-1.443 1.139h-4.347l2.311-8.674a.762.762 0 0 1 1.472 0Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M73.12 144.113 129.864 97.6l44.177 34.313M160.712 121.195l13.329-11.395 41.511 33.55",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M143.955 65.956h14.472c-.549-4.139.824-7.6 4.119-10.386 3.783-3.107 8.276-2.41 10.688-1.339 2.413 1.072 4.204 2.545 5.446 5.324.527 1.17.884 2.16 1.073 2.97",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M173.659 68.244c.804-2.786 2.455-4.608 4.952-5.465 3.745-1.286 7.296.427 8.714 2.15 1.419 1.722 1.868 3.106 2.136 4.55.179.963.243 2.076.193 3.34 3.155-.129 5.27.507 6.346 1.906 1.301 1.673 1.435 3.674.961 5.147-.474 1.473-2.055 3.622-5.022 3.622h-60.171M124.151 73.581h49.509M110.441 73.581h6.094M259.729 96.456H274.2c-.549-4.139.824-7.6 4.119-10.386 3.784-3.107 8.276-2.41 10.689-1.338 2.412 1.071 4.204 2.544 5.446 5.323.526 1.17.884 2.16 1.073 2.97",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M289.434 98.744c.804-2.786 2.454-4.608 4.951-5.465 3.745-1.285 7.296.427 8.715 2.15 1.418 1.722 1.868 3.106 2.136 4.55.178.963.243 2.076.193 3.34 3.154-.129 5.27.507 6.346 1.906 1.301 1.673 1.434 3.673.96 5.147-.474 1.473-2.055 3.622-5.021 3.622h-60.172M239.925 104.081h49.509M226.215 104.081h6.093",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M266.964 181.314v9.189M266.964 172.165v2.325M266.964 57.776v84.691",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M266.964 199.775a4.572 4.572 0 0 0 4.57-4.575 4.572 4.572 0 0 0-4.57-4.575 4.572 4.572 0 0 0-4.57 4.575 4.572 4.572 0 0 0 4.57 4.575Z",
    stroke: "#8CD3F8",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M266.964 200.538v22.112c0 8.388-15.234 8.388-15.234 0v-10.028l4.951 5.453",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.964 154.788c5.048 0 9.14-1.809 9.14-3.813 0-5.053-4.092-9.15-9.14-9.15-5.048 0-9.14 4.097-9.14 9.15 0 2.766 4.092 3.813 9.14 3.813Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M136.72 163.726c-5.517 1.149-8.941-4.363-8.941-4.363h-.007s-2.612 4.533-7.977 4.533c-5.141 0-7.962-4.533-7.962-4.533h-.009s-2.608 4.533-7.973 4.533c-5.143 0-7.962-4.533-7.962-4.533h-.009s-4.413 5.602-9.812 4.454",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M184.706 163.726c-5.517 1.149-8.942-4.363-8.942-4.363h-.007s-2.612 4.533-7.977 4.533c-5.141 0-7.962-4.533-7.962-4.533h-.009s-2.607 4.533-7.973 4.533c-5.142 0-7.962-4.533-7.962-4.533h-.008s-4.414 5.602-9.812 4.454",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M232.69 163.726c-5.517 1.149-8.942-4.363-8.942-4.363h-.006s-2.612 4.533-7.978 4.533c-5.14 0-7.962-4.533-7.962-4.533h-.008s-2.608 4.533-7.973 4.533c-5.143 0-7.962-4.533-7.962-4.533h-.009s-4.414 5.602-9.812 4.454M283.722 163.726c-5.517 1.149-8.942-4.363-8.942-4.363h-.006s-2.612 4.533-7.977 4.533c-5.141 0-7.962-4.533-7.962-4.533h-.009s-2.608 4.533-7.973 4.533c-5.143 0-7.962-4.533-7.962-4.533h-.009s-4.413 5.602-9.812 4.454",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M331.707 163.726c-5.517 1.149-8.942-4.363-8.942-4.363h-.007s-2.612 4.533-7.977 4.533c-5.141 0-7.962-4.533-7.962-4.533h-.009s-2.607 4.533-7.973 4.533c-5.142 0-7.962-4.533-7.962-4.533h-.008s-4.414 5.602-9.812 4.454M245.638 178.976c-5.517 1.149-8.942-4.363-8.942-4.363h-.006s-2.612 4.533-7.977 4.533c-5.141 0-7.962-4.533-7.962-4.533h-.009s-2.608 4.533-7.973 4.533c-5.143 0-7.962-4.533-7.962-4.533h-.009s-4.413 5.602-9.812 4.454M394.926 163.726c-5.518 1.149-8.942-4.363-8.942-4.363h-.007s-2.612 4.533-7.977 4.533c-5.141 0-7.962-4.533-7.962-4.533h-.009s-2.608 4.533-7.973 4.533c-5.143 0-7.962-4.533-7.962-4.533h-.009s-4.413 5.602-9.812 4.454M341.609 178.976c-5.517 1.149-8.942-4.363-8.942-4.363h-.006s-2.613 4.533-7.978 4.533c-5.14 0-7.962-4.533-7.962-4.533h-.008s-2.608 4.533-7.973 4.533c-5.143 0-7.962-4.533-7.962-4.533h-.009s-4.414 5.602-9.812 4.454",
    stroke: "#C2E8FF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.587 236.175h84.162l5.179 3.25H285.07v-1.615l.517-1.635Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M290.957 225.7a3.81 3.81 0 0 0 3.808-3.812 3.81 3.81 0 0 0-3.808-3.813 3.81 3.81 0 0 0-3.809 3.813 3.81 3.81 0 0 0 3.809 3.812ZM306.952 214.263a6.86 6.86 0 0 0 6.855-6.863 6.858 6.858 0 0 0-6.855-6.862 6.858 6.858 0 0 0-6.855 6.862 6.86 6.86 0 0 0 6.855 6.863Z",
    stroke: "#C2E8FF",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.53 239.425h90.44l3.474 3.05 1.671 5.698-8.669 9.862h-70.003l-7.242-3.488-4.67-4.219-5.001-10.903Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M286.871 235.994h80.845c3.294 0 6.404 1.525 8.424 4.13l5.074 6.545-5.103 7.522a10.66 10.66 0 0 1-8.821 4.678h-59.324c-6.45-.402-11.405-2.056-14.865-4.962-3.057-2.568-5.854-7.527-8.39-14.878a2.288 2.288 0 0 1 2.16-3.035Z",
    stroke: "#8CD3F8",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.653 240.2c0-3.785 1.493-7.276 4.57-10.539 3.077 3.263 4.57 6.754 4.57 10.539 0 3.784-1.493 7.275-4.57 10.538-3.077-3.263-4.57-6.754-4.57-10.538Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.653 253.925c0 3.784 1.493 7.275 4.57 10.538 3.077-3.263 4.57-6.754 4.57-10.538 0-3.785-1.493-7.276-4.57-10.539-3.077 3.263-4.57 6.754-4.57 10.539ZM345.797 219.263v16.35c0 .842-.682 1.525-1.524 1.525h-13.277a1.524 1.524 0 0 1-1.119-2.56l14.598-15.832a.761.761 0 0 1 1.322.517ZM322.184 268.916v-9.666c0-.842-.682-1.525-1.523-1.525h-7.603a1.524 1.524 0 0 0-1.09 2.591l8.91 9.133a.761.761 0 0 0 1.306-.533ZM360.268 268.916v-9.666c0-.842-.682-1.525-1.523-1.525h-7.604a1.524 1.524 0 0 0-1.089 2.591l8.91 9.133a.761.761 0 0 0 1.306-.533Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M310.76 235.761c2.031 3.46 3.046 7.223 3.046 11.289 0 4.067-1.015 8.134-3.046 12.2",
    stroke: "#8CD3F8",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M313.807 246.669h66.265",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M299.335 246.288a3.048 3.048 0 0 0 3.046-3.05 3.048 3.048 0 0 0-3.046-3.05 3.049 3.049 0 0 0-3.047 3.05 3.049 3.049 0 0 0 3.047 3.05Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m158.24 208.699 6.218-5.892h63.191l-2.399 8.129-67.01-2.237Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.444 208.925c1.295-1.515 2.098-2.278 2.41-2.287.312-.009 22.41-.009 66.294 0l.542 2.287-3.881 7.494-11.279 3.619c-19.174.063-33.583.199-43.228.407l-4.701-.49-4.401-3.536-1.756-7.494Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M227.663 203.207h-60.248a10.66 10.66 0 0 0-8.872 4.753l-2.42 3.634 2.42 3.634a10.66 10.66 0 0 0 8.872 4.754h44.733c4.22-.363 7.473-1.61 9.757-3.741 2.284-2.131 4.203-6.476 5.758-13.034Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.853 206.638c0-2.7-1.118-5.191-3.423-7.519-2.306 2.328-3.424 4.819-3.424 7.519s1.118 5.191 3.424 7.519c2.305-2.328 3.423-4.819 3.423-7.519Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.853 216.55c0 2.7-1.118 5.191-3.423 7.519-2.306-2.328-3.424-4.819-3.424-7.519s1.118-5.191 3.424-7.519c2.305 2.328 3.423 4.819 3.423 7.519ZM182.8 191.566v12.784h13.647l-12.327-13.302a.76.76 0 0 0-1.32.518ZM199.557 226.296v-5.934c0-.842.682-1.525 1.523-1.525h3.962a1.524 1.524 0 0 1 1.09 2.591l-5.269 5.401a.761.761 0 0 1-1.306-.533ZM170.613 226.296v-5.934c0-.842.682-1.525 1.523-1.525h3.963a1.524 1.524 0 0 1 1.09 2.591l-5.269 5.401a.761.761 0 0 1-1.307-.533Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M209.458 202.825c-1.523 2.923-2.285 5.846-2.285 8.769s.762 5.846 2.285 8.769",
    stroke: "#8CD3F8",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M205.65 211.594h-47.985",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M215.933 210.45a1.904 1.904 0 0 1-1.904-1.906 1.904 1.904 0 1 1 3.808 0 1.905 1.905 0 0 1-1.904 1.906Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m104.923 259.786 6.218-5.891h63.192l-2.4 8.128-67.01-2.237Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.128 260.013c1.295-1.516 2.098-2.279 2.41-2.288.312-.009 22.41-.009 66.294 0l.542 2.288-3.881 7.493-11.28 3.62c-19.173.063-33.582.199-43.227.407l-4.701-.491-4.401-3.536-1.756-7.493Z",
    fill: "#C2E8FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M174.347 254.294h-60.248a10.662 10.662 0 0 0-8.873 4.754l-2.42 3.633 2.42 3.634a10.662 10.662 0 0 0 8.873 4.754h44.732c4.221-.363 7.473-1.61 9.757-3.741 2.284-2.131 4.204-6.476 5.759-13.034Z",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.537 257.725c0-2.7-1.118-5.191-3.424-7.519-2.305 2.328-3.424 4.819-3.424 7.519s1.119 5.191 3.424 7.519c2.306-2.328 3.424-4.819 3.424-7.519Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.537 267.638c0 2.7-1.118 5.19-3.424 7.519-2.305-2.329-3.424-4.819-3.424-7.519 0-2.701 1.119-5.191 3.424-7.52 2.306 2.329 3.424 4.819 3.424 7.52ZM129.484 242.654v12.784h13.647l-12.327-13.303a.76.76 0 0 0-1.32.519ZM146.24 277.383v-5.933c0-.842.682-1.525 1.523-1.525h3.963a1.524 1.524 0 0 1 1.09 2.59l-5.269 5.401a.76.76 0 0 1-1.307-.533ZM117.297 277.383v-5.933c0-.842.682-1.525 1.523-1.525h3.962a1.524 1.524 0 0 1 1.09 2.59l-5.269 5.401a.76.76 0 0 1-1.306-.533Z",
    fill: "#8CD3F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M156.142 253.913c-1.524 2.923-2.285 5.845-2.285 8.768 0 2.923.761 5.846 2.285 8.769",
    stroke: "#8CD3F8",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M152.334 262.681h-47.985",
    stroke: "#8CD3F8",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M162.616 261.538a1.906 1.906 0 0 1 0-3.813 1.906 1.906 0 0 1 0 3.813Z",
    fill: "#8CD3F8"
  }));
};
EmptyResultsIcon.defaultProps = {
  width: "457",
  height: "305",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const ResultsTable = props => /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Table, props);
const getHeaders = (0, _memoizeOne.default)(({
  selectionType = 'none',
  onSelect,
  onVersionChange,
  showTypes,
  statuses,
  disableDropdown,
  selectedRows,
  versions,
  additionalColumns,
  columns
}) => {
  const defaultHeaders = [];
  const headers = [];
  if (selectionType === 'multiple') {
    headers.push({
      label: null,
      className: styles.checkCell,
      render: (row, index) =>
      /*#__PURE__*/
      /* this div applies flex and helps to vertically align */
      _react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        className: styles.check,
        testId: `table-select-${index}`,
        onChange: ({
          value
        }) => onSelect(row, value)
      }))
    });
  }
  if (selectionType === 'single') {
    headers.push({
      label: null,
      className: styles.checkCell,
      render: (row, index) =>
      /*#__PURE__*/
      /* this div applies flex and helps to vertically align */
      _react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        className: styles.check,
        checked: selectedRows.includes(row),
        testId: `table-select-${index}`,
        onChange: () => onSelect(row)
      }))
    });
  }
  defaultHeaders.push({
    id: 'name',
    label: 'Name',
    render: row => {
      var _row$highlight;
      return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.AssetNameLink, {
        asset: row.asset,
        className: styles.assetName,
        useFullURLPath: true
      }, (_row$highlight = row.highlight) !== null && _row$highlight !== void 0 && _row$highlight.name ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, row.highlight.name) : row.asset.name);
    }
  }, {
    id: 'version',
    label: 'Version',
    render: row => /*#__PURE__*/_react.default.createElement(_VersionDropdown.default, {
      asset: row.asset,
      onChange: onVersionChange,
      statuses: statuses,
      disabled: disableDropdown === true || selectionType === 'none' && disableDropdown !== false
    }),
    className: styles.noWrap
  });
  if (showTypes) {
    defaultHeaders.push({
      id: 'type',
      label: 'Type',
      render: row => /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.AssetType, {
        type: row.asset.type
      }),
      className: styles.noWrap
    });
  }
  defaultHeaders.push({
    id: 'dateModified',
    label: 'Date modified',
    render: row => new Date(row.asset.modifiedAt).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }),
    className: styles.noWrap
  }, {
    id: 'organization',
    label: 'Organization',
    render: row => row.asset.organization.name
  }, {
    id: 'createdBy',
    label: 'Created by',
    render: row => `${row.asset.createdBy.firstName} ${row.asset.createdBy.lastName}`
  });
  if (columns) {
    headers.push(...columns.map(columnId => defaultHeaders.find(({
      id: headerId
    }) => headerId === columnId)));
  } else {
    headers.push(...defaultHeaders);
  }
  if (additionalColumns) {
    headers.push(...additionalColumns.map(header => _objectSpread(_objectSpread({}, header), {}, {
      render: row => {
        var _versions;
        const selectedVersion = (_versions = versions[`${row.asset.groupId}:${row.asset.assetId}`]) !== null && _versions !== void 0 ? _versions : row.asset.version;
        return header.render(row, selectedVersion);
      }
    })));
  }
  return headers;
});
const Results = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    value: {
      results,
      isLoading,
      statuses,
      showTypes,
      hasExecutedQuery
    },
    selectionType,
    disableDropdown,
    onSelect,
    additionalColumns,
    columns
  } = props;
  const [selectedRows, setSelectedRows] = _react.default.useState([]);
  const [updatedVersions, setUpdatedVersions] = _react.default.useState({});
  const handleSelection = (rows, versions) => {
    onSelect === null || onSelect === void 0 || onSelect(rows.map(({
      asset: {
        groupId,
        assetId,
        version
      }
    }) => {
      var _versions2;
      return {
        groupId,
        assetId,
        version: (_versions2 = versions[`${groupId}:${assetId}`]) !== null && _versions2 !== void 0 ? _versions2 : version
      };
    }));
  };
  const handleVersionChange = asset => {
    const newVersions = _objectSpread(_objectSpread({}, updatedVersions), {}, {
      [`${asset.groupId}:${asset.assetId}`]: asset.version
    });
    setUpdatedVersions(newVersions);
    handleSelection(selectedRows, newVersions);
  };
  const handleRowSelection = (row, isSelected = true) => {
    let rows;
    if (selectionType === 'multiple') {
      if (!isSelected) {
        rows = selectedRows.filter(selectedRow => selectedRow !== row);
      } else {
        rows = [...selectedRows, row];
      }
    } else if (selectionType === 'single') {
      rows = [row];
    } else {
      return;
    }
    setSelectedRows(rows);
    handleSelection(rows, updatedVersions);
  };
  const headers = getHeaders({
    selectionType,
    onSelect: handleRowSelection,
    onVersionChange: handleVersionChange,
    versions: updatedVersions,
    selectedRows,
    showTypes,
    statuses,
    disableDropdown,
    additionalColumns,
    columns
  });
  _react.default.useImperativeHandle(ref, () => ({
    clear: () => {
      setSelectedRows([]);
    }
  }), [setSelectedRows]);
  if (!hasExecutedQuery) {
    return null;
  }
  if (isLoading && results.length === 0) {
    var _additionalColumns$le;
    return /*#__PURE__*/_react.default.createElement(_ResultsLoading.default, {
      headers: headers,
      hideStatusCell: (statuses === null || statuses === void 0 ? void 0 : statuses.length) === 1,
      additionalColumnsCount: (_additionalColumns$le = additionalColumns === null || additionalColumns === void 0 ? void 0 : additionalColumns.length) !== null && _additionalColumns$le !== void 0 ? _additionalColumns$le : 0
    });
  }
  if (results.length === 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": "table-search-empty",
      className: styles.empty
    }, /*#__PURE__*/_react.default.createElement(EmptyResultsIcon, null), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.message
    }, "Your search did not return any asset.", /*#__PURE__*/_react.default.createElement("br", null), "Review your wording or try different filters."));
  }
  return /*#__PURE__*/_react.default.createElement(ResultsTable, {
    className: styles.table,
    headers: headers,
    rows: results,
    testId: "search-results"
  });
});
var _default = exports.default = Results;
//# sourceMappingURL=Results.js.map